import { isBackAndLayOnURL } from '../utils';

export const NO_WELCOME_DIALOG = `NO_WELCOME_DIALOG_ODTP${isBackAndLayOnURL && '_BL'}`;
export const WELCOME_DIALOG = 'WelcomeDialog';

export const PAYOUT_NA = '-'; // payout not available (displayed in limits popup, when winning chances are 0% or 100%)
